<template>
  <div class="d-flex" style="position: relative">
    <v-dialog ref="dialog" v-model="showPicker" :return-value="dates" persistent width="390px" :disabled="readonly">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          outlined
          :value="dates"
          :label="model.title"
          :error-messages="error"
          :disabled="disabled"
          :hide-details="config.hideDetails || false"
          readonly
          persistent-placeholder
          placeholder="не задано - не задано"
          :clearable="!!(start || end) && !readonly"
          :dense="config.dense || false"
          :append-icon="!(start || end) ? 'mdi-calendar' : ''"
          @click.prevent="openDialog"
          @click:append.prevent="openDialog"
          @click:clear="onClear()"
        />
      </template>
      <v-date-picker
        v-if="showPicker"
        v-model="d"
        @input="setDate($event)"
        full-width
        range
        :first-day-of-week="1"
        show-week
        l1andscape
        show-adjacent-months
        prev-month-aria-label
      >
        <v-btn @click="onClear()" v-if="1" :title="$t(`clear`)"> <v-icon>fas fa-trash-alt </v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="isWeek = !isWeek" :disabled="!!params.type">
              <v-icon left class="mx-0"> {{ isWeek ? "mdi-checkbox-outline" : "mdi-checkbox-blank-outline" }} </v-icon>
              Неделя
            </v-btn>
          </template>
          <span>Выбор по неделям</span>
        </v-tooltip>
        <v-btn @click="showPicker = false" title="Закрыть"><v-icon>fas fa-times </v-icon></v-btn>
        <v-btn color="primary" @click="onSave()">Ok</v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import { forEach } from "lodash";
import { isObject } from "lodash";
import { isWeakMap } from "lodash";

export default {
  props: {
    values: Object,
    config: { type: Object, default: {} },

    model: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      date: null,
      d: [],
      initValue: this.values,
      showPicker: false,
      start: null,
      end: null,
      isWeek: false,
      params: {},
    };
  },
  watch: {
    showPicker(v) {
      this.isWeek = false;
      if (v) {
        this.getParams();
        this.selectDate(this.values);
      }
    },
    isWeek(v) {
      if (v) this.setDate(this.start);
    },
  },
  computed: {
    text: {
      get() {
        //console.log("vvvv", this.value, this.value ? new Date(this.value).date : "Не указано");
        return this.setText();
      },
      set(v) {
        this.$emit("input", null);
      },
    },

    dates: {
      get: function () {
        let res;
        let s = this.getDateValue(this.model.dates[0]);
        let e = this.getDateValue(this.model.dates[1]);
        res = [
          //   this.values[this.model.dates[0]] ? new Date(this.values[this.model.dates[0]] || date).date : null,
          //  this.values[this.model.dates[1]] ? new Date(this.values[this.model.dates[1]]).date : null,
          s ? new Date(s).toLocaleDateString("ru-RU") : "не задано",
          e ? new Date(e).toLocaleDateString("ru-RU") : "не задано",
        ].join(" - ");
        return res;
      },
    },
    readonly() {
      if (this.config?.readonly || this.model?.readonly) return true;
      return false;
    },
  },
  methods: {
    getParams() {
      console.log("get params", this.model);
      if (this.model?.params?.type) {
        let res;
        if (this.model.params.type?.value) res = this.model.params.type.value;
        if (this.model.params.type?.func) {
          const f = eval(this.model.params.type.func);
          res = f(this.values);
          this.$set(this.params, "type", res);
        }
        this.isWeek = res == "week";
      }
    },
    setDate(v) {
      let s, e;
      if (typeof v === "string") {
        s = v;
        e = null;
      } else {
        s = v?.[0] || null;
        e = v?.[1] || null;
      }
      console.log("set date", v, s);
      if (!s) {
        e = null;
        return;
      }
      if (!this.isWeek) {
        e = v?.[1] || null;
      } else {
        const selected = new Date(s);
        const day = selected.getDay(); // 0 (вс) — 6 (сб)

        // Понедельник (1) как начало недели
        const start = new Date(selected);
        start.setDate(selected.getDate() - ((day + 6) % 7));
        s = new Date(start).date;

        const end = new Date(start);
        end.setDate(start.getDate() + 6);
        e = new Date(end).date;
        const range = [s, e];
        this.d = range;
        console.log("range", range);
      }
      let r = [s, e].sort();
      this.start = r[0];
      this.end = r[1];
    },
    getDateValue(v) {
      return this.values[v] ? new Date(this.values[v] || date).date : null;
    },
    selectDate(d) {
      let res;
      this.start = this.getDateValue(this.model.dates[0]);
      this.end = this.getDateValue(this.model.dates[1]);
      if (this.end) res = [this.start, this.end];
      else res = [this.start];
      res = [this.start, this.end];
      console.log("select date ", res);
      this.d = res;
    },
    setText() {
      return this.value ? new Date(this.value).date : "";
    },
    openDialog() {
      if (this.disabled) return;
      this.showPicker = true;
    },
    onSave() {
      this.showPicker = false;
      let obj = {
        [this.model.dates[0]]: this.start,
        [this.model.dates[1]]: this.end,
      };
      this.$emit("input", obj);
      console.log("emit ", obj);
      this.$refs.dialog.save();
      //      this.dates = [this.start, this.end || this.start].join(" - ");
    },
    onClear() {
      this.showPicker = false;
      let obj = {
        [this.model.dates[0]]: null,
        [this.model.dates[1]]: null,
      };
      this.setDate(null);
      this.$emit("input", obj);
      console.log("emit ", obj);
      this.$refs.dialog.save();
      //this.$emit("input", "");
    },
  },
};
</script>
